import React, {Component} from "react"
import PaperBlock from "../../ui/PaperBlock"
import { List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core"
import ItemIcon from '@material-ui/icons/Attachment'
import FolderIcon from '@material-ui/icons/Folder'
import BackIcon from '@material-ui/icons/KeyboardReturn'

/**
 * items - список шаблонов и папок
 * selected - выбранный шаблон
 * folder_id - id папки которая отображается.
 * exclude - папка которую нельзя выбрать. Нужно, что бы предотвратить возможность копировать папку в саму себя.
 * 
 * onClickItem(attachment)
 * onDoubleClickItem(attachment)
 * onBackClick(parent_folder_id)
 */

class FolderList extends Component {

    render() {
        return <PaperBlock style = {{width: "auto"}}>
            <List>
                {this.props.folder_id ? 
                    <ListItem 
                        button
                        onDoubleClick = {e => {
                            e.stopPropagation()
                            if (typeof this.props.onBackClick === "function") {
                                this.props.onBackClick(this.props.folder_id)
                            }
                        }}
                    >
                        <ListItemIcon>
                            <BackIcon/>
                        </ListItemIcon>
                        <ListItemText primary = {".."}/>
                    </ListItem>
                : undefined}
                {this.props.items.map((item, key) => 
                    item.type === 0 ?
                        <ListItem
                            key = {key}
                            button
                            disabled = {this.props.exclude ? this.props.exclude.id == item.id  : false}
                            selected = {this.props.selected ? this.props.selected.id === item.id : false} 
                            onClick = {e => {
                                e.stopPropagation()
                                if (typeof this.props.onClickItem === "function") {
                                    this.props.onClickItem(item)
                                }
                            }}
                            onDoubleClick = {e => {
                                e.stopPropagation()
                                if (typeof this.props.onDoubleClickItem === "function") {
                                    this.props.onDoubleClickItem(item)
                                }
                            }}
                        >
                            <ListItemIcon>
                                <FolderIcon/>
                            </ListItemIcon>
                            <ListItemText primary = {item.name}/>
                        </ListItem>
                    :
                        undefined
                )}
            </List>
        </PaperBlock>
    }

}

export default FolderList